/* Модальное окно: портал, блокировка прокрутки, Escape и анимация выхода. */
import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ title, sub, onClose, children, dark = false, wide = false }) {
  const [closing, setClosing] = useState(false);

  const close = useCallback(() => {
    setClosing(true);
    setTimeout(onClose, 240);
  }, [onClose]);

  useEffect(() => {
    document.body.classList.add('is-locked');
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.classList.remove('is-locked');
      document.removeEventListener('keydown', onKey);
    };
  }, [close]);

  return createPortal(
    <div className={`modal-root is-open${closing ? ' is-closing' : ''}`}>
      <div className="modal__backdrop" onClick={close} />
      <div
        className={`modal scroll-area${dark ? ' modal--dark scroll-area--dark' : ''}${wide ? ' modal--wide' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
      >
        <button className="modal__close" type="button" aria-label="Закрыть" onClick={close}>
          ×
        </button>
        {title ? <h2 className="modal__title">{title}</h2> : null}
        {sub ? <p className="modal__sub">{sub}</p> : null}
        <div className="modal__body">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
